import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Link } from 'react-router-dom'; // Assuming Link is from react-router-dom
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Button, Breadcrumbs, Box, Link as MuiLink } from "@mui/material";
import {
  CallingState,
  SpeakerLayout,
  StreamCall,
  StreamTheme,
  StreamVideo,
  StreamVideoClient,
  useCallStateHooks,
  CancelCallButton,
  SpeakingWhileMutedNotification,
  ToggleAudioPublishingButton,
  ToggleVideoPublishingButton,
} from "@stream-io/video-react-sdk";
import { StreamChat } from "stream-chat";
import {
  Chat,
  Channel,
  ChannelHeader,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from "stream-chat-react";
import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import "@stream-io/video-react-sdk/dist/css/styles.css";
import "stream-chat-react/dist/css/v2/index.css";
import "./online-consultation.css";
import { Helmet } from "react-helmet";
import { useGetOnlineConsultToken } from "../../api/online-consultation";
import { AuthContext } from "../../context/AuthContextProvider";
import { toast } from "sonner";
import { swap } from "formik";
import ReportPreview from "../../components/ReportPreview";
import { BlankPreview } from "../../components/BlankPreview";
import { useGetEcgDetails } from "../../api/EcgReports";
import { set } from "lodash";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const apiKey = "t88gqkq5g2tw";
// const MySwal = withReactContent(Swal);

const OnlineConsultation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [videoClient, setVideoClient] = useState(null);
  const [call, setCall] = useState(null);
  const [chatClient, setChatClient] = useState(null);
  const [channel, setChannel] = useState(null);
  const { user } = useContext(AuthContext);
  const [chatVisible, setChatVisible] = useState(true);
  const [closing, setClosing] = useState(false);
  const [reportData, setReportData] = useState(1);
  const [openReportPopup, setOpenReportPopup] = useState(false);
  const [isEnding, setIsEnding] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const { id } = useParams();

  const callId = id;
  const userId = user._id;
  const userName = user.firstName;
  const { token, isLoading, caseStatus } = useGetOnlineConsultToken({ report_id: id });
  const { EcgReport, isLoading: isLoadingReport } = useGetEcgDetails({}, id);
  const videoClientRef = useRef(null);
  const callRef = useRef(null);
  const chatClientRef = useRef(null);
  const channelRef = useRef(null);


  const handleShareLocation = async () => {
    if (!navigator.geolocation) {
      toast.error("Location not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const locationUrl = `https://maps.google.com/?q=${latitude},${longitude}`;

        try {
          await channel.sendMessage({
            text: `📍 Shared location: ${locationUrl}`,
          });

          toast.success("Location shared in chat");
        } catch (err) {
          console.error(err);
          toast.error("Unable to share location");
        }
      },
      () => toast.error("Location permission denied")
    );
  };

  const handleAttachmentUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const response = await channel.sendFile(file);

      await channel.sendMessage({
        text: "📎 Attachment shared",
        attachments: [
          {
            type: "file",
            asset_url: response.file,
            title: file.name,
          },
        ],
      });

      toast.success("File shared");
    } catch (err) {
      console.error(err);
      toast.error("File upload failed");
    }
  };


  useEffect(() => {
    if (!isLoading && !initialized) {
      setInitialized(true)

      const init = async () => {
        try {
          const user = {
            id: userId,
            name: userName,
            image: `https://getstream.io/random_svg/?id=${userId}&name=${userId}`,
          };

          // Connect Chat Client
          const chatClient = StreamChat.getInstance(
            process.env.REACT_APP_STREAM_API_KEY || apiKey
          );
          await chatClient.connectUser({ id: userId }, token);

          // Watch channel
          const chatChannel = chatClient.channel("messaging", callId);
          await chatChannel.watch();

          // Connect Video Client
          // const videoClient = new StreamVideoClient({
          //   apiKey: process.env.REACT_APP_STREAM_API_KEY || apiKey,
          //   token,
          //   user: { id: userId },
          // });

          // const call = videoClient.call("default", callId);
          // await call.join({ create: true });

          const videoClient = new StreamVideoClient({
            apiKey: process.env.REACT_APP_STREAM_API_KEY || apiKey,
            token,
            user: { id: userId },
          });

          const call = videoClient.call("default", callId);
          //This will prevent the duplication of the call (so we dont see any replicas of the videos)
          if (call.state.callingState !== "joined") {
            await call.join({ create: true });
          }
          videoClientRef.current = videoClient;
          callRef.current = call;
          chatClientRef.current = chatClient;
          channelRef.current = chatChannel;

          setVideoClient(videoClient);
          setCall(call);
          setChatClient(chatClient);
          setChannel(chatChannel);
        } catch (err) {
          console.error("Error initializing video/chat:", err);
          toast.error("Unable to open video call");
        }
      };

      init();

      return () => {
        const cleanup = async () => {
          try {
            // if (streamCall) await streamCall.leave();
            // if (streamVideoClient) await streamVideoClient.disconnectUser();
            // if (streamChatClient) await streamChatClient.disconnectUser();
            await callRef.current?.leave();
            await videoClientRef.current?.disconnectUser();
            await channelRef.current?.stopWatching();
            await chatClientRef.current?.disconnectUser();
          } catch (err) {
            console.error("Cleanup error:", err);
          }
        };
        cleanup();
      };
    }
  }, [isLoading]);
  // useEffect(() => {
  //   return () => {
  //     try {
  //       call?.leave();
  //       channel?.stopWatching();
  //       chatClient?.disconnectUser();
  //       videoClient?.disconnectUser();
  //     } catch (e) {
  //       console.error("cleanup error", e);
  //     }
  //   };
  // }, []);



  const handleViewECGReport = () => {
    // open the ECG report in a full page popuop
    setReportData(EcgReport);
    setOpenReportPopup(true);
  };

  const handleEndCall = async () => {
    try {
      setIsEnding(true);
      setClosing(true); // Show closing animation


      // if (call && call.state.callingState !== "left") {
      //   await call.leave();
      // }
      if (callRef.current && callRef.current.state.callingState !== "left") {
        await callRef.current.leave();
      }

      navigate(-1)
      if (videoClient?.disconnectUser) {
        await videoClient.disconnectUser();
      }
      if (channel) {
        await channel.stopWatching();
        await channel.hide();
      }
      if (chatClient) {
        await chatClient.disconnectUser();
      }
      setChatVisible(false);
      setClosing(false);
    } catch (err) {
      console.error("Error ending call & chat:", err);
      setClosing(false);
      navigate(-1);
    }
  };
  if (caseStatus === "closed") {
    return (
      <div className="loading-screen">
        <Icon icon="iconamoon:file-close-duotone" width="75" height="75" color="gray" />
        <br />
        <Typography variant="h6" component="h2">
          This case has been closed.
        </Typography>
        <br />
        <Button
          component={Link}
          to="/cases"
          variant="contained"
          startIcon={<ArrowBackIcon />}
          sx={{
            backgroundColor: "#5751E9",
            fontSize: "14px",
            fontWeight: 600,
            textTransform: "none",
            height: "42px",
            borderRadius: "10px",
            whiteSpace: "nowrap",
            px: 5,
            "&:hover": {
              backgroundColor: "#433AC7",
              color: "white",
            },
          }}
        >
          Back to Cases
        </Button>
      </div>
    );
  }
  if (!videoClient || !call || !chatClient || !channel) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Connecting to your consultation...</p>

      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Online - Consultation</title>
      </Helmet>

      {closing && (
        <div className="closing-backdrop">
          <svg className="closing-icon" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" stroke="#007bff" strokeWidth="5" fill="none" />
            <path
              d="M30 50 L45 65 L70 35"
              stroke="#007bff"
              strokeWidth="5"
              fill="none"
            />
          </svg>
          <p>Ending consultation...</p>
        </div>
      )}

      <div
        className="page-wrapper"
        style={{
          height: "100dvh",
          paddingTop: "75px", // header height
          fontFamily: "Figtree",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        {/* Breadcrumb — natural height */}
        {/* <Box sx={{ px: "18px", pt: 1 }}>
    <Breadcrumbs sx={{ mb: 1 }}>
      <MuiLink
        underline="hover"
        onClick={() => navigate("/cases")}
        sx={{
          cursor: "pointer",
          fontFamily: "Figtree",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "1",
          letterSpacing: "-0.02em",
          color: "var(--app-text)",
        }}
      >
        Referred Cases
      </MuiLink>

      <Typography
        sx={{
          fontFamily: "Figtree",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "1",
          letterSpacing: "-0.02em",
          color: "var(--app-text)",
        }}
      >
        {EcgReport?.id}
      </Typography>
    </Breadcrumbs>
  </Box> */}

        {/* Main Content Area */}
        <div
          className="main-content"
          style={{
            flex: 1,
            display: "flex",
            overflow: "hidden",
            paddingLeft: "18px",
            paddingRight: "10px",
          }}
        >
          {/* Video section */}
          <div
            className={`video-section ${chatVisible ? "video-expanded" : "video-full"}`}
            style={{
              flex: chatVisible ? 0.7 : 1,
              marginRight: "10px",
              minHeight: 0,
            }}
          >
            <StreamVideo client={videoClient}>
              <StreamCall call={call}>
                <MyUILayout
                  onEndCall={handleEndCall}
                  closing={closing}
                  chatVisible={chatVisible}
                  setChatVisible={setChatVisible}
                  handleViewECGReport={handleViewECGReport}
                  handleShareLocation={handleShareLocation}
                  handleAttachmentUpload={handleAttachmentUpload}
                />
              </StreamCall>
            </StreamVideo>
          </div>

          {/* Chat section */}
          {chatVisible && !isEnding && (
            <div
              className="chat-drawer open"
              style={{
                flex: 0.3,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Chat client={chatClient} theme="messaging light">
                <Channel channel={channel}>
                  <Window>
                    <ChannelHeader />
                    <MessageList />
                    <MessageInput />
                  </Window>
                  <Thread />
                </Channel>
              </Chat>
            </div>
          )}
        </div>
      </div>

      <FullPagePopup
        open={openReportPopup}
        handleClose={() => setOpenReportPopup(false)}
        EcgReport={reportData}
        previewReport={true}
      />
    </>
  );
};
export const MyUILayout = ({ onEndCall, closing, chatVisible, setChatVisible, handleViewECGReport,handleShareLocation,handleAttachmentUpload }) => {
  const { useCallCallingState } = useCallStateHooks();
  const callingState = useCallCallingState();

  if (callingState !== CallingState.JOINED && !closing) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading video...</p>
      </div>
    );
  }
  if (closing) return null;

  return (
    <StreamTheme>
      <SpeakerLayout participantsBarPosition="bottom" />
      {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}> */}
      {/* Native Call Controls */}
      {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}> */}
      <CallControls onLeave={onEndCall} chatVisible={chatVisible} setChatVisible={setChatVisible} handleViewECGReport={handleViewECGReport}  handleShareLocation={handleShareLocation}
  handleAttachmentUpload={handleAttachmentUpload}/>
      {/* </div> */}
      {/* </div> */}
    </StreamTheme>
  );
};
// export const CallControls = ({ onLeave, chatVisible, setChatVisible, handleViewECGReport }) => (
//   <div className="call-controls-wrapper">
//     <SpeakingWhileMutedNotification>
//       <ToggleAudioPublishingButton />
//     </SpeakingWhileMutedNotification>

//     <ToggleVideoPublishingButton />

//     <button onClick={() => setChatVisible((prev) => !prev)} className="circle-btn">
//       <Icon icon="gridicons:chat" width={22} height={22} />
//     </button>

//     <button onClick={handleViewECGReport} className="circle-btn">
//       <Icon icon="basil:document-solid" width={22} height={22} />
//     </button>

//     <CancelCallButton onLeave={onLeave} />
//   </div>
// );
export const CallControls = ({
  onLeave,
  chatVisible,
  setChatVisible,
  handleViewECGReport,
  handleShareLocation,
  handleAttachmentUpload
}) => (
  <div className="call-controls-wrapper">

    <SpeakingWhileMutedNotification>
      <ToggleAudioPublishingButton />
    </SpeakingWhileMutedNotification>

    <ToggleVideoPublishingButton />

    {/* Chat */}
    <button
      onClick={() => setChatVisible((prev) => !prev)}
      className="circle-btn"
    >
      <Icon icon="gridicons:chat" width={22} height={22} />
    </button>

    {/* Location */}
    <button onClick={handleShareLocation} className="circle-btn">
      <Icon icon="mdi:map-marker" width={22} height={22} />
    </button>

    {/* Attachment */}
    <label className="circle-btn">
      <Icon icon="mdi:paperclip" width={22} height={22} />
      <input
        type="file"
        style={{ display: "none" }}
        onChange={handleAttachmentUpload}
      />
    </label>

    {/* ECG */}
    <button onClick={handleViewECGReport} className="circle-btn">
      <Icon icon="basil:document-solid" width={22} height={22} />
    </button>

    {/* End call */}
    <CancelCallButton onLeave={onLeave} />
  </div>
);


const circleBtnStyle = {
  width: "40px",
  height: "40px",
  backgroundColor: "var(--app-surface-2)",
  color: "var(--app-text)",
  border: "none",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};


export function FullPagePopup({ open, handleClose, EcgReport, previewReport }) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
    >
      <AppBar sx={{ position: "relative", background: "#2F2F2F" }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            ECG Report Preview
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 16, right: 16, zIndex: 1000 }}
          >
            <Icon icon="mdi:close" width={28} height={28} color="white" />
          </IconButton>
        </Toolbar>
      </AppBar>

      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: "20px",
          background: "var(--app-surface-2)",
        }}
      >
        <div className="row" style={{ width: "100%" }}>
          <div className="col-md-12">
            {previewReport ? (
              <ReportPreview type="full" Link={Link} data={EcgReport} />
            ) : (
              <BlankPreview
                icon="nopreview"
                title="No Preview Available"
                subtitle="Select a report to preview"
              />
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}



export default OnlineConsultation;
